import React, { useState, useEffect, useRef } from 'react';
import styles from './PropertyKhata.module.css';

const { khata_box, radio_position } = styles;
function CommonKhataDesk(props) {
  const { id, label, onClickCards, showRadioAndBg } = props;
  let show = showRadioAndBg === id;

  return (
    <div
      onClick={e => {
        onClickCards(id);
      }}
      className={`flex items-center flex-col justify-center 
  rounded-lg relative cursor-pointer 
 ${show ? 'border border-green-1000 bg-green-100 ' : 'border border-navy-200 '}
 hover:border-green-1000 hover:bg-green-100 mr-6 mb-6 ${khata_box} `}
    >
      {show ? <div className={`${radio_position}`}>{props.children}</div> : ''}
      <label htmlFor="" className="text-black-400 text-sm m-2">
        {label}
      </label>
    </div>
  );
}

export default CommonKhataDesk;
